













import { Mixins, Component, Prop } from "vue-property-decorator";
import UserMixin from '../../mixins/UserMixin';
import { TooltipDirective } from '../directives/Tooltip';

@Component({
    directives: {TooltipDirective}
})
export default class UserIcon extends Mixins(UserMixin) {
    static MIN_STATUS_ICON_SIZE = 10;

    @Prop({default: 44}) size: number;
    @Prop() fontSize: number;
    @Prop({default: false}) isEntered: boolean;
    @Prop({default: false}) isOnline: boolean;
    @Prop({default: 10}) onlineStatusSize: number;

    get sideSize(): string {
        return this.size + 'px';
    }

    get tooltipProps() {
        return {
            title: this.$t('common.userLoggedIn')
        }
    }

    get localFontSize(): string {
        if (this.fontSize) {
            return this.fontSize + 'px';
        }

        switch(this.size) {
            case 23:
                return '8px';
            case 24:
                return '9px';
            case 28:
                return '10px';
            case 30:
                return '10px';
            case 32:
                return '11px';
            case 138:
                return '25px';
            default:
                return '14px';
        }
    }

    get cssStyle(): Record<string, any> {
        return {
            background: this.profileColor,
            width: this.sideSize,
            height: this.sideSize,
            flex: '0 0 ' + this.sideSize,
            lineHeight: this.sideSize,
            fontSize: this.localFontSize
        }
    }

    get userIconStyle(): Record<string, any> {
        return {
            width: `${Math.max(this.onlineStatusSize, Math.floor(this.size / 2.75), UserIcon.MIN_STATUS_ICON_SIZE)}px`,
            height: `${Math.max(this.onlineStatusSize, Math.floor(this.size / 2.75), UserIcon.MIN_STATUS_ICON_SIZE)}px`
        }
    }

  get userOnlineIconStyle(): Record<string, any> {
    return {
      width: `${this.onlineStatusSize || UserIcon.MIN_STATUS_ICON_SIZE}px`,
      height: `${this.onlineStatusSize || UserIcon.MIN_STATUS_ICON_SIZE}px`
    }
  }
}
